import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { urlServer } from '../global_constants';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient:HttpClient) { 
    this.indicatorSubject=new Subject();
    this.kpiSuggestionsSubjects = new Map();
    this.newsSubject=new Subject();
    this.pdfSubject= new Subject();
    this.programSubject= new Subject();
    this.todaySubject= new Subject();
    this.newslistSubject= new Subject();
    this.startVisitSubject= new Subject();
    this.terminatedSubject= new Subject();
    this.terminatedlistSubject= new Subject();
    this.affectedSubject= new Subject();
    this.planedSubject= new Subject();
    this.cancelVisitSubject= new Subject();
    this.reportVisitSubject= new Subject();
    this.calendarSubject = new Subject();
    this.smartSubject = new Subject();
    this.visittovalidSubject = new Subject();
    this.validationVisitsSubject = new Subject();
    this.visitsInprogressSubject = new Subject();
    this.reviveCommercialsSubject = new Subject();
    this.sendResponseVisitSubject = new Subject();
    this.getMessagesVisitSubject = new Subject();
    this.notifCommentslistSubject = new Subject();
    this.markAsReadSubject = new Subject();
    this.actionsPlanSubjectIndicators = new Subject();
    this.actionsPlanSubject = new Subject();
    this.visitsManagement = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      {this.token = localStorage.getItem("token")}
    else {
      this.token = sessionStorage.getItem("token")}
    }
  token:any;
  //INDICATOR variables
  pathApiIndicator:string="/v1/indicators/dashboard";
  indicatorSubject:Subject<any>;
  userRequest:any;
  urlRequestIndicator: string =urlServer.concat(this.pathApiIndicator);

  //KPI of use Suggestions by Commercial variables
  pathApiKpiSuggestions:string="/v1/visits/kpi/";
  kpiSuggestionsSubjects:Map<string, Subject<any>> = new Map();;
  urlRequestKpi: string =urlServer.concat(this.pathApiKpiSuggestions);

  //News variables
  pathApiNews:string="/v1/news/3";
  newsSubject:Subject<any>;
  newsRequest:any;
  urlRequestNews: string =urlServer.concat(this.pathApiNews);

  //Newslist variables
  pathApiNewslist:string="/v1/news/100";
  newslistSubject:Subject<any>;
  newslistRequest:any;
  urlRequestNewslist: string =urlServer.concat(this.pathApiNewslist);

  //PROGRAM variables
  pathApiProgram:string="/v1/visits/planning";
  programSubject:Subject<any>;
  programRequest:any;
  urlRequestProgram: string =urlServer.concat(this.pathApiProgram);

  //PDF variables
  pathApiPdf1:string="/v1/visit/";
  pathApiPdf2:string="/action/";
  pathApiPdf3:string="/report";
  pdfSubject:Subject<any>;
  pdfRequest:any;
  urlRequestPdf: string="";

  //TODAY variables
  pathApiToday:string="/v1/dashboard/visits/today";
  todaySubject:Subject<any>;
  todayRequest:any;
  urlRequestToday: string =urlServer.concat(this.pathApiToday);

  //Vsiste Terminée variables
  pathApiTerminated:string="/v1/dashboard/visits/last/3";
  terminatedSubject:Subject<any>;
  terminatedRequest:any;
  urlRequestTerminated: string =urlServer.concat(this.pathApiTerminated);

  //START VISIT variables
  pathApiActionsVisit:string="/v1/dashboard/visit/";
  startVisitSubject:Subject<any>;
  //Liste Vsiste Terminée variables
  pathApiTerminatedlist:string="/v1/dashboard/visits/last/100";
  terminatedlistSubject:Subject<any>;
  terminatedlistRequest:any;
  urlRequestTerminatedlist: string =urlServer.concat(this.pathApiTerminatedlist);
  //Cancel VISIT variables
  cancelVisitSubject:Subject<any>;
  //Report VISIT variables
  reportVisitSubject:Subject<any>;

  //Vsiste affectée variables
  pathApiAffected:string="/v1/commercial/visits";
  affectedSubject:Subject<any>;
  affectedRequest:any;
  urlRequestAffected: string =urlServer.concat(this.pathApiAffected);

  //PLANEDVISIT variables
  pathApiPlaned:string="/v1/visit/myweek";
  planedSubject:Subject<any>;
  planedRequest:any;
  urlRequestPlaned: string =urlServer.concat(this.pathApiPlaned);

  //CALENDAR VISITS variables
  pathApiCalendar:string="/v1/visits/calendar";
  calendarSubject:Subject<any>;
  calendarRequest:any;
  urlRequestCalendar: string =urlServer.concat(this.pathApiCalendar);

  //Liste Vsiste a valider variables
  pathApiVisttovalid:string="/v1/visits/invalid";
  visittovalidSubject:Subject<any>;
  visittovalidRequest:any;
  urlRequestVisittovalid: string =urlServer.concat(this.pathApiVisttovalid);

  //Liste Vsistes In progress variables
  pathApiVistsInprogress:string="/v1/visits/inprogress";
  visitsInprogressSubject:Subject<any>;
  visitsInprogressRequest:any;
  urlRequestVisitInprogress: string =urlServer.concat(this.pathApiVistsInprogress);

  //Validate/Refuse visits of commercials variables
  pathApiValidateVisits:string="/v1/visit/invalid/";
  validationVisitsSubject:Subject<any>;
  validateVisitsRequest:any;
  urlRequestValidationVisits: string =urlServer.concat(this.pathApiValidateVisits);

  //SMART GESTION variables
  pathApiSmart:string="/v1/visits/smart";
  smartSubject:Subject<any>;
  urlRequestSmart: string =urlServer.concat(this.pathApiSmart);

  //REVIVE COMMERCIALS variables
  pathApiRevive:string="/v1/visits/revive";
  reviveCommercialsSubject:Subject<any>;
  urlRequestRevive: string =urlServer.concat(this.pathApiRevive);


  //GET COMMENTS RESPONSE VISIT
  pathApiGetMessagesVisit:string="/v1/visit/responses/";
  getMessagesVisitSubject:Subject<any>;
  urlRequestGetMessagesVisit: string =urlServer.concat(this.pathApiGetMessagesVisit);

  //SEND COMMENT RESPONSE VISIT
  pathApiSendResponseVisit:string="/v1/visit/response/";
  sendResponseVisitSubject:Subject<any>;
  urlRequestSendComment: string =urlServer.concat(this.pathApiSendResponseVisit);

  
  //SEND COMMENT RESPONSE VISIT
  pathApiNotifsVisitsResponse:string="/v1/visits/lastComments";
  urlRequestNotifsVisits: string =urlServer.concat(this.pathApiNotifsVisitsResponse);
  notifCommentslistSubject:Subject<any>;

  //MARK COMMENT AS READ
  pathApiMarkAsRead:string="/v1/visit/comments";
  urlRequestMarkAsRead: string =urlServer.concat(this.pathApiMarkAsRead);
  markAsReadSubject:Subject<any>;

  //GET ACTIONS PLAN
  pathApiactionsPlanIndicators:string="/v1/actions/plan/indicators/";
  urlRequestactionsPlanIndicators: string =urlServer.concat(this.pathApiactionsPlanIndicators);
  actionsPlanSubjectIndicators:Subject<any>;
  pathApiactionsPlan:string="/v1/actions/plan/";
  urlRequestactionsPlan: string =urlServer.concat(this.pathApiactionsPlan);
  actionsPlanSubject:Subject<any>;

  //GET VISITS MANAGEMENT BY COMMERCIAL
  pathApiVisitsManagement:string="/v1/customers/smart/commercial/";
  urlRequestVisitsManagement: string =urlServer.concat(this.pathApiVisitsManagement);
  visitsManagement:Subject<any>;

  getIndicator(){
    this.indicatorSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestIndicator,{headers: header}).subscribe((response: any) => {
        this.indicatorSubject.next(response);
        this.indicatorSubject.complete();
    },
      error => {
      }
    );
  }
  getKpiSuggestions(commercial:any,period:any){
    // Créer une clé unique pour chaque combinaison commercial/period
    const key = `${commercial}_${period}`;
    
    // Créer un nouveau Subject seulement si nous n'en avons pas déjà un pour cette combinaison
    if (!this.kpiSuggestionsSubjects.has(key)) {
      this.kpiSuggestionsSubjects.set(key, new Subject());
    }
    const subject = this.kpiSuggestionsSubjects.get(key)!;
    // this.kpiSuggestionsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestKpi+commercial+"/"+period,{headers: header}).subscribe((response: any) => {
        subject.next(response);
    },
      error => {
      }
    );
    return subject.asObservable();
  }

  getNews(){
    this.newsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestNews,{headers: header}).subscribe((response: any) => {
        this.newsSubject.next(response);
        this.newsSubject.complete();
    },
      error => {
      }
    );
  }
  getNewslist(){
    this.newslistSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestNewslist,{headers: header}).subscribe((response: any) => {
        this.newslistSubject.next(response);
        this.newslistSubject.complete();
    },
      error => {
      }
    );
  }
  getPdf(id_visit:any){
    this.urlRequestPdf= urlServer.concat(this.pathApiPdf1+id_visit,this.pathApiPdf3);
    this.pdfSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestPdf= urlServer.concat(this.pathApiPdf1+id_visit,this.pathApiPdf3)
    ,{headers: header}).subscribe((response: any) => {
        this.pdfSubject.next(response);
        this.pdfSubject.complete();
      },
      error => {
      }
    );
  }
  getProgram(){
    this.programSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestProgram,{headers: header}).subscribe((response: any) => {
        this.programSubject.next(response);
        this.programSubject.complete();
    },
      error => {
      }
    );
  }
  getToday(){
    this.todaySubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestToday,{headers: header}).subscribe((response: any) => {
        this.todaySubject.next(response);
        this.todaySubject.complete();
    },
      error => {
      }
    );
  }
  startVisit(visit:any) {
    var causeBody ={};
    var urlRequestStartVisit= urlServer.concat(this.pathApiActionsVisit,visit,"/start");
    this.startVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(urlRequestStartVisit,causeBody,{headers: header}).subscribe((response: any) => {
        this.startVisitSubject.next(response);
        this.startVisitSubject.complete();
    },
      error => {
      }
    );
  }

  bodyFinish:any;
  terminateVisit(visit:any,mode:any){
    var urlRequestFinishVisit= urlServer.concat(this.pathApiActionsVisit,visit,"/finish/",mode);
    this.startVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(urlRequestFinishVisit,this.bodyFinish,{headers: header}).subscribe((response: any) => {
        this.startVisitSubject.next(response);
        this.startVisitSubject.complete();
    },
      error => {
      }
    );
  }
  cancelVisit(visit:any,causeBody:any) {
    var urlRequestStartVisit= urlServer.concat(this.pathApiActionsVisit,visit,"/cancel");
    this.cancelVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(urlRequestStartVisit,causeBody,{headers: header}).subscribe((response: any) => {
        this.cancelVisitSubject.next(response);
        this.cancelVisitSubject.complete();
      },
      error => {
      }
    );
  }
  reportVisit(visit:any,causeBody:any) {
    var urlRequestStartVisit= urlServer.concat(this.pathApiActionsVisit,visit,"/report");
    this.reportVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(urlRequestStartVisit,causeBody,{headers: header}).subscribe((response: any) => {
        this.reportVisitSubject.next(response);
        this.reportVisitSubject.complete();
      },
      error => {
      }
    );
  }
  getTerminated(){
    this.terminatedSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestTerminated,{headers: header}).subscribe((response: any) => {
        this.terminatedSubject.next(response);
        this.terminatedSubject.complete();
    },
      error => {
      }
    );
  }
  getTerminatedlist(){
    this.terminatedlistSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestTerminatedlist,{headers: header}).subscribe((response: any) => {      
        this.terminatedlistSubject.next(response);
        this.terminatedlistSubject.complete();
      },
      error => {
      }
    );
  }
  getNotifCommentslist(){
    this.notifCommentslistSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestNotifsVisits,{headers: header}).subscribe((response: any) => {      
        this.notifCommentslistSubject.next(response);
        this.notifCommentslistSubject.complete();
      },
      error => {
      }
    ); 
  }
  getAffected(status: number){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return this.httpClient.get(`${this.urlRequestAffected}/${status}`,{headers: header});
  }
  newVisitRequest:any;
  getPlaned() {
    this.planedSubject = new Subject();
    const createdvisit = this.newVisitRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestPlaned,createdvisit,{headers: header}).subscribe((response: any) => {
        this.planedSubject.next(response);
        this.planedSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getVisitsCalendar(start:any,end:any) {
    this.calendarSubject = new Subject();
    var olddate = new Date('2023-03-24T03:24:00');
    var dateNow = new Date();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    
    this.httpClient.get(this.urlRequestCalendar+"/start="+formatDate(start)+"&end="+formatDate(end),{headers: header}).subscribe((response: any) => {
        this.calendarSubject.next(response);
        this.calendarSubject.complete();        
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getVisittovalid(){
    this.visittovalidSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestVisittovalid,{headers: header}).subscribe((response: any) => {
        this.visittovalidSubject.next(response);
        this.visittovalidSubject.complete();
    },
      error => {
      }
    );
  }
  getVisitsInprogress(){
    this.visitsInprogressSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestVisitInprogress,{headers: header}).subscribe((response: any) => {
        this.visitsInprogressSubject.next(response);
        this.visitsInprogressSubject.complete();
    },
      error => {
      }
    );
  }
  validationVisitsRequest:any;
  validateVisits(uuids:any[],action:any, motif:any) {
    this.validationVisitsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    var requestBody = {
      "motif":motif,
      "visitsToValidate":uuids
    }
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(this.urlRequestValidationVisits+action,requestBody,{headers: header}).subscribe((response: any) => {
        this.validationVisitsSubject.next(response);
        this.validationVisitsSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  smartGestion() {
    this.smartSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestSmart,{headers: header}).subscribe((response: any) => {
        this.smartSubject.next(response);
        this.smartSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  sendReviveToCommercials() {
    this.reviveCommercialsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestRevive,{headers: header}).subscribe((response: any) => {
        this.reviveCommercialsSubject.next(response);
        this.reviveCommercialsSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getMessagesVisit(visit:any) {
    this.getMessagesVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestGetMessagesVisit+visit,{headers: header}).subscribe((response: any) => {      
        this.getMessagesVisitSubject.next(response);
        this.getMessagesVisitSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  requestResponseVisit:any;
  sendResponseVisit(visit:any) {
    this.sendResponseVisitSubject = new Subject();
    const responsevisit = this.requestResponseVisit;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestSendComment+visit,responsevisit,{headers: header}).subscribe((response: any) => {
        this.sendResponseVisitSubject.next(response);
        this.sendResponseVisitSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  markAsRead(visit:any, customer: any) {
    this.markAsReadSubject = new Subject();
    const responsevisit = {
      "visit":visit,
      "customer": customer
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(this.urlRequestMarkAsRead,responsevisit,{headers: header}).subscribe((response: any) => {
        this.markAsReadSubject.next(response);
        this.markAsReadSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getActionsPlanIndicators(uuid:any) {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );    
    return this.httpClient.get(this.urlRequestactionsPlanIndicators+uuid,{headers: header});
  }
  getActionsPlan(uuid:any,status:any) {
    this.actionsPlanSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );    
    this.httpClient.get(this.urlRequestactionsPlan+uuid+"/"+status,{headers: header}).subscribe((response: any) => {
        this.actionsPlanSubject.next(response);
        this.actionsPlanSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  generateCsv(uuid:any,status:any) {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );    
    return this.httpClient.get(this.urlRequestactionsPlan+uuid+"/"+status+"/export",{headers: header});
  }

  getVisitsManagement(commercial:any){
    
    this.visitsManagement = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization',"Bearer "+this.token );  
      
    this.httpClient.get(this.urlRequestVisitsManagement+commercial,{headers: header}).subscribe((response: any) => {
        this.visitsManagement.next(response);
        
        this.visitsManagement.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
    //return this.httpClient.get(this.urlRequestactionsPlan+uuid+"/"+status+"/export",{headers: header});
  }
}

function formatDate(date:Date) { 
  date = new Date(date);
  var stDate = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
  
  return stDate;
 }